import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getFILEUPTableStructure";
export const UPDATE_TABLE_DATA = "getFILEUPTableData";
export const EXPORT_TABLE_DATA = "exportFILEUPTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setFILEUPTableStructure";
export const SET_TABLE_DATA = "setFILEUPTableData";
export const SET_TABLE_FILTER = "setFILEUPTableFilter";
export const SET_TABLE_PAGE = "setFILEUPTablePage";
export const SET_TABLE_PERPAGE = "setFILEUPTablePerPage";
export const SET_TABLE_SORTBY = "setFILEUPTableSortBy";
export const SET_TABLE_SORTORDER = "setFILEUPTableSortOrder";
export const SET_EXPORT_LINK = "setFILEUPExportLink";
export const SET_FILTERS_DATA = "setFILEUPFiltersData";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  filters_data: [],
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  /**
   * for table title, descripton
   * */
  getFILEUPTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getFILEUPTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getFILEUPCarriers(state) {
    return state.table_structure.carriers;
  },
  getFILEUPTableState(state) {
    return state.table_state;
  },

  getFILEUPTableHeaders(state) {
    return state.table_structure.columns;
  },

  getFILEUPTableFilters(state) {
    return state.table_structure.filters;
  },

  getFILEUPTableData(state) {
    return state.table_data.data;
  },

  getFILEUPExportUrl(state) {
    return state.export_link;
  },
  getFILEUPTypes(state) {
    return state.table_structure.types;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context, payload) {
    return new Promise((resolve) => {
      ApiService.post(`/account/uploads`, payload)
        .then(({ data }) => {
          // console.log("suc", data);
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      let address = "/account/uploads/datatable";
      if (payload.type) {
        address = address + `?type=${payload.type}`;
      }
      ApiService.post(address, payload.data)
        .then(({ data }) => {
          // console.log("data of datatable ", data);
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(`/account/uploads/export?type=${payload.type}`, payload)
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_FILTERS_DATA](state, filter_data) {
    state.filters_data = filter_data;
  },
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
